import React, { useState } from 'react';
import { Drawer, Radio, RadioGroup, Input, InputGroup, useToaster, Message } from 'rsuite';
const divStyle = {
  border: '1px solid rgba(128, 128, 128, 0.293)',
  borderRadius: '5px',
  padding: '10px 10px 10px 0px'
};
const styles = {
  marginBottom: 5
};
const Daction = {
  textAlign: 'left',
  padding: '10px',
  gap: '5px',
  display: 'flex',
  flexDirection: 'column'
};

export default function GenerateAccess({ open, close, typeCode, setMobileList, mobileList }) {
  const [value, setValue] = React.useState('Allow');
  const [newMobile, setNewMobile] = useState('');
  const toaster = useToaster();
  const handleAction = actionType => {
    if (newMobile.trim() !== '') {
      const isAllow = actionType === 'Allow';

      const index = mobileList.findIndex(item => item.mobileno.trim() === newMobile.trim());

      if (isAllow) {
        setMobileList(prevList => {
          const update = [...prevList];
          if (index !== -1) {
            update[index].mobilests = true;
            update[index].typecode = typeCode;
          } else {
            update.push({ mobileno: newMobile.trim(), typecode: typeCode, mobilests: true });
          }
          return update;
        });
        setNewMobile('');
      } else if (index !== -1) {
        setMobileList(prev => {
          const update = [...prev];
          update[index].mobilests = false;
          update[index].typecode = typeCode;
          return update;
        });
        setNewMobile('');
      } else {
        toaster.push(
          <Message showIcon type="error">
            Mobile number not found in the list.
          </Message>,
          { placement: 'topEnd' }
        );
      }
    } else {
      toaster.push(
        <Message showIcon type="error">
          Please enter a mobile number.
        </Message>,
        { placement: 'topEnd' }
      );
    }
  };

  return (
    <Drawer open={open} onClose={close} size="xs" backdrop="static">
      <Drawer.Header>
        <Drawer.Title>
          <h5>Restrict Access</h5>
        </Drawer.Title>
      </Drawer.Header>
      <Drawer.Body>
        <Drawer.Actions style={Daction}>
          <div>
            <RadioGroup name="radioList" inline value={value} onChange={setValue}>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  gap: '10px',
                  flexDirection: 'column'
                }}
              >
                <div style={divStyle}>
                  <Radio value="Allow">
                    <h6>Allow Specific Mobile's</h6>
                    Allow specified mobile to access your catalogue while blocking everyone else.
                  </Radio>
                </div>
                <div style={divStyle}>
                  <Radio value="Not-allow">
                    <h6>Block Specific mobile no</h6>
                    List which visitors should be blocked from accessing your catalogue.
                  </Radio>
                </div>
              </div>
            </RadioGroup>
          </div>

          <div style={{ marginTop: '20px' }}>
            <label htmlFor="">Mobile no.</label>
            <InputGroup inside style={styles}>
              <Input
                type="mobile"
                value={newMobile}
                onChange={value => setNewMobile(value)}
                style={{ width: '100% !important' }}
              />
              <InputGroup.Button onClick={() => handleAction(value)} type="button">
                {value == 'Allow' ? 'Allow' : 'Block'}
              </InputGroup.Button>
            </InputGroup>
          </div>
          {mobileList.length &&
            mobileList.map(item => {
              return (
                <InputGroup inside style={styles} key={item.mobileno}>
                  <Input
                    disabled
                    value={item.mobileno}
                    style={{ color: !item.mobilests ? 'red' : '' }}
                  />
                </InputGroup>
              );
            })}
        </Drawer.Actions>
      </Drawer.Body>
    </Drawer>
  );
}
